// extracted by mini-css-extract-plugin
export default {"container":"Team_container__yCXxM","main":"Team_main__1BtYD","text":"Team_text__26pI7"};